import { Text } from '@wix/wix-ui-tpa/cssVars';
import React, { useMemo, useState } from 'react';
import { useConfig } from '../../../contexts/config-context';
import { useFieldActions } from '../../../contexts/field-actions-context';
import { useTranslation } from '../../../contexts/translation-context';
import { useSlotSelectedFromTP } from '../actions/slot-selected-from-tp';
import { bulkSlotsSize } from '../appointment-state';
import { Actions, Components } from '../bi-types';
import { useAppointmentContext } from '../context/appointment-context';
import { useAppointmentBi } from '../utils/bi';
import { formatTimezone } from '../utils/format-timezone';
import { DatePicker } from './datepicker/datepicker-wut';
import { TimeSlots } from './slots';
import { classes } from './time-slot-picker.st.css';
import { LOCATIONS_METHOD } from './types';
export const TimeSlotPicker = _ref => {
  let {
    visibility = 'visible',
    fieldId
  } = _ref;
  const {
    language,
    isComposer,
    isEditor
  } = useConfig();
  const {
    t
  } = useTranslation();
  const {
    appointmentFieldProps,
    appointmentState,
    setAppointmentState
  } = useAppointmentContext();
  const bi = useAppointmentBi();
  const {
    formatDescription,
    locationType
  } = appointmentFieldProps;
  const [isReloadingSlots, setIsReloadingSlots] = useState(false);
  const [isFetchingDates, setIsFetchingDates] = useState(false);
  const {
    actions
  } = useFieldActions();
  useSlotSelectedFromTP({
    setIsReloadingSlots
  });
  const timezone = useMemo(() => formatTimezone({
    timezone: appointmentState.timezone,
    language
  }), [appointmentState.timezone, language]);
  const onDateClicked = async data => {
    if (data != null && data.selectedDate) {
      setIsReloadingSlots(true);
      setAppointmentState({
        selectedDate: data.selectedDate
      });
      bi == null || bi.report({
        action: Actions.CLICK,
        component: Components.DATE
      });
      const availabilitySlotsToUpdate = await (actions == null || actions.getAvailabilitySlots == null ? void 0 : actions.getAvailabilitySlots({
        serviceId: appointmentFieldProps == null ? void 0 : appointmentFieldProps.initialData.service.id,
        timeZone: (appointmentState == null ? void 0 : appointmentState.timezone) || '',
        selectedDate: data.selectedDate
      }));
      setAppointmentState({
        currentSlotBulkSize: bulkSlotsSize,
        selectedDate: data.selectedDate,
        availabilitySlots: availabilitySlotsToUpdate
      });
      appointmentFieldProps == null || appointmentFieldProps.onChange(undefined);
      setIsReloadingSlots(false);
    }
  };
  const handleOnWeekChange = async (fromDate, toDate) => {
    if (isComposer || isEditor) {
      return;
    }
    setIsFetchingDates(true);
    bi == null || bi.report({
      action: Actions.CLICK,
      component: Components.PAGINATION
    });
    const availabilityDates = await (actions == null || actions.getAvailabilityDates == null ? void 0 : actions.getAvailabilityDates({
      serviceId: appointmentFieldProps == null ? void 0 : appointmentFieldProps.initialData.service.id,
      timeZone: (appointmentState == null ? void 0 : appointmentState.timezone) || '',
      fromDate,
      toDate
    }));
    setAppointmentState({
      availabilityDates
    });
    setIsFetchingDates(false);
  };
  return /*#__PURE__*/React.createElement("div", {
    style: {
      visibility
    }
  }, /*#__PURE__*/React.createElement(DatePicker, {
    availableDates: appointmentState.availabilityDates,
    selectedDate: appointmentState.selectedDate,
    onDateChange: date => onDateClicked({
      selectedDate: date
    }),
    onWeekChange: handleOnWeekChange,
    disabled: isReloadingSlots || isFetchingDates
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.textRegion
  }, /*#__PURE__*/React.createElement(Text, {
    tagName: "span",
    className: classes.paragraph
  }, `${t('form.appointment.timezone.label')}: ${timezone}`), /*#__PURE__*/React.createElement(Text, {
    tagName: "span",
    className: classes.paragraph
  }, locationType === LOCATIONS_METHOD.OS_LOCATION ? t('form.appointment.meeting-format.in-person-location-method-os-location') : formatDescription)), /*#__PURE__*/React.createElement(TimeSlots, {
    isReloadingSlots: isReloadingSlots,
    fieldId: fieldId
  }));
};
//# sourceMappingURL=index.js.map